"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = {
  name: 'RefreshBtn',
  props: {
    tip: {
      type: String,
      default: '刷新当前数据'
    }
  },
  methods: {
    click: function click() {
      this.$emit('click');
    }
  }
};
exports.default = _default;